import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { loadCustomPresets } from '~/api/data/presets/queries';
import {
  submitCreateTriggerDefinition,
  submitUpdateTriggerDefinition
} from '~/api/data/triggers/mutations';
import {
  loadTriggerDefinition,
  loadTriggerDefinitions,
  shouldRevalidateTriggerList
} from '~/api/data/triggers/queries';
import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import { WorkflowsPage, WorkflowsDebugPage } from '~/pages/workflows';
import { WorkflowGalleryPage } from '~/pages/workflows/gallery';
import { WorkflowExecutionsPage } from '~/pages/workflows/executions';
import { WorkflowExecutionDetailPage } from '~/pages/workflows/execution-detail';
import { WorkflowBuilderPage } from '~/pages/workflows/builder/builder';
import { WorkflowTriggersPage } from '~/pages/workflows/triggers';
import { WorkflowTriggerExecutionsPage } from '~/pages/workflows/trigger-executions';
import { TriggerEditPage } from '~/pages/workflows/trigger-edit';
import { TriggerCreationPage } from '~/pages/workflows/trigger-create';
import { TriggerDetailPage } from '~/pages/workflows/trigger-detail';
import { TriggerRunDetailPage } from '~/pages/workflows/trigger-run-detail';
import { EventDetailPage } from '~/pages/workflows/event-detail';

export const workflowRoutes: RouteObject[] = [
  {
    path: 'workflows',
    element: <WorkflowsPage />,
    children: [
      {
        index: true,
        element: <Navigate to="triggers" replace />
      },
      {
        path: 'triggers',
        loader: merge({
          triggerDefinitions: loadTriggerDefinitions,
          customPresets: loadCustomPresets
        }),
        shouldRevalidate: shouldRevalidateTriggerList,
        element: <WorkflowTriggersPage />,
        children: [
          {
            path: 'events/:eventId',
            element: <TriggerRunDetailPage />
          },
          {
            path: ':triggerId',
            element: <TriggerDetailPage />
          }
        ]
      },
      {
        path: 'events',
        element: <WorkflowTriggerExecutionsPage />,
        children: [
          {
            path: ':eventId',
            element: <EventDetailPage />
          }
        ]
      },
      {
        path: 'gallery',
        element: <WorkflowGalleryPage />
      },
      {
        path: 'executions',
        element: <WorkflowExecutionsPage />
      }
    ]
  },
  {
    path: 'workflows/builder/:draftId',
    element: <WorkflowBuilderPage />
  },
  {
    path: 'workflows/executions/:id',
    element: <WorkflowExecutionDetailPage />
  },
  {
    path: 'workflows/debug/:id?/:version?',
    element: <WorkflowsDebugPage />
  },
  {
    path: 'workflows/triggers/new/email',
    loader: merge({ customPresets: loadCustomPresets }),
    shouldRevalidate: () => false,
    action: byMethod({ POST: submitCreateTriggerDefinition }),
    element: <TriggerCreationPage />
  },
  {
    path: 'workflows/triggers/new',
    loader: merge({ customPresets: loadCustomPresets }),
    shouldRevalidate: () => false,
    action: byMethod({ POST: submitCreateTriggerDefinition }),
    element: <TriggerCreationPage />
  },
  {
    path: 'workflows/triggers/:triggerId/edit',
    loader: merge({
      triggerDefinition: loadTriggerDefinition,
      customPresets: loadCustomPresets
    }),
    shouldRevalidate: () => false,
    action: byMethod({ PUT: submitUpdateTriggerDefinition }),
    element: <TriggerEditPage />
  },
  {
    path: 'workflows/triggers/runs/:eventId',
    element: <TriggerRunDetailPage />
  }
];
